import React from 'react'
import PropTypes from 'prop-types'
import { ModuleError } from './errors'
import stashError from '../utils/stash-error'
import { connect } from 'react-redux'
import { logError } from 'portal-modules/common/api/commonApi'
import { getSectionNameByPath } from '../utils/get-section-name-by-path'

class ErrorBoundary extends React.Component {
  state = {
    error: null,
    info: null,
  }

  componentDidCatch(error, info) {
    console.log('ErrorBoundary caught an error!', error, info);
    console.log('ErrorBoundary props:', this.props);
    console.log('ErrorBoundary context:', this.context);
    let sectionName = this.props.section || getSectionNameByPath()
    this.setState({ error, info })
    this.props.offline
      ? stashError({ message: error.message, stack: error.stack, ...info })
      : logError({
          section: sectionName,
          message: error.message,
          componentName: this.props.componentName,
          stack: error.stack,
          user_token: this.props.user_token,
          ...info,
        })
    if (window?.NREUM?.noticeError)
      window?.NREUM.noticeError(error, {
        section: sectionName,
        message: error.message,
        componentName: this.props.componentName,
        stack: error.stack,
        user_token: this.props.user_token,
        ...info,
      })
  }

  render() {
    const { children, renderError } = this.props
    return this.state.error ? renderError(this.state) : children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  section: PropTypes.string,
  /** Render prop when an error is thrown. It gets passed the error and info objects. */
  renderError: PropTypes.func,
  offline: PropTypes.bool,
  componentName: PropTypes.string,
  user_token: PropTypes.string,
}

ErrorBoundary.defaultProps = {
  renderError: () => <ModuleError />,
  componentName: '',
  section: '',
}

export default connect(({ offline, user }) => ({
  offline,
  user_token: user?.token,
}))(ErrorBoundary)
